/* eslint-disable camelcase */
import Model from '../../../Api/Models/Model';
import User from '../../../Api/Models/User';

import GetCasinoGameSessions from '../CRM/Responses/CasinoGameSessions';

import CasinoGame from './CasinoGame';
import CasinoTransaction from './CasinoTransaction';

export default class CasinoGameSessions extends Model {
    readonly id: number;
    readonly casino_provider_id: number;
    readonly casino_game_id: number;
    readonly user_id: number;
    readonly currency_id: number;
    readonly session_id: number;
    readonly created_at: string;
    readonly is_canceled: boolean;
    readonly amount: number;
    readonly win: number | null;
    readonly bet: number | null;

    // Relationships
    readonly user?: User;
    readonly casino_transactions?: CasinoTransaction;
    readonly casino_game: CasinoGame | null;

    constructor(transaction: Partial<GetCasinoGameSessions>) {
        super();
        this.assignDataToProps(transaction, [
            'id',
            'casino_provider_id',
            'casino_game_id',
            'user_id',
            'currency_id',
            'session_id',
            'user',
            'casino_transactions',
            'casino_game',
            'is_canceled',
            'amount',
            'win',
            'bet',
            'created_at',
        ]);
    }
}
